import { createAction, props } from '@ngrx/store';
import { IRegion } from '../../models/region.model';
import { EntityActions } from '../entity.actions';

export const fromRegionActions = { ...EntityActions.create<IRegion>('[Region]'), nameChanged: createAction(`[Region] Name Changed`, props<{ name: string }>()), suggest: createAction(`[Region] Suggest`) };
